// The AI ranker's priority bands, best-first, with the operator-facing label. Mirrors
// _BAND_ORDER in people_discovery.py and must be reordered with it: the BE sends rows
// pre-sorted by that order and the shortlist is its top two bands, so a disagreement here
// would show the operator a different ranking from the one that chose the shortlist.
export const PRIORITY_ORDER: { band: string; label: string }[] = [
  { band: "primary", label: "Primary target" },
  { band: "sustainability", label: "Sustainability / ESG" },
  { band: "secondary", label: "Also strong" },
  { band: "other", label: "Other" },
];
export const bandRank = (band: string): number => {
  const i = PRIORITY_ORDER.findIndex((p) => p.band === band);
  return i === -1 ? PRIORITY_ORDER.length : i;
};
export const bandLabel = (band: string): string =>
  PRIORITY_ORDER.find((p) => p.band === band)?.label ?? "Other";

// Only a primary - or a senior sustainability contact filling a slot a primary left
// free - takes one of the three. A secondary is real and worth having but is never a
// first approach, so it stays below the fold however short the top is. That makes a
// short or empty shortlist a NORMAL outcome with people underneath, and the operator
// has to be told which of the two they are looking at - an empty top with 20 contacts
// beneath must never read as "we found nobody". Mirrors _SHORTLIST_BANDS and
// _SHORTLIST_SIZE in people_discovery.py; CRM contacts ride on top of the three rather
// than consuming a slot, so they are not counted here either.
export const SHORTLIST_BANDS = ["primary", "sustainability"];
export const SHORTLIST_SIZE = 3;
